module.exports = __webpack_public_path__ + "img/whatsapp.4e31374d.png";